















































































































































































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component
export default class BulkEnrollmentUploadRules extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  get accountTypeUpdatesAcceptedCopy (): string {
    return this.custodianSettingsStore.disableEmployeeEdit ? "N" : "Y";
  }

}
